let baseUrl=process.env.REACT_APP_BASE_URL||"https://arcorinic-dev-6b4c8cc29614.herokuapp.com";

if (!/^https?:\/\//i.test(baseUrl)) {
   baseUrl = "https://" + baseUrl;
       }
export const PUBLIC_IMAGE=`${baseUrl}/public`
export const PUBLIC_STATUS=`${PUBLIC_IMAGE}/status`
export const PUBLIC_SIGNS= `${PUBLIC_IMAGE}/signs/`
export const PUBLIC_FIGURES= `${PUBLIC_IMAGE}/figures/`
export const STATUS_1_IMAGE=`${PUBLIC_STATUS}/status1.png`
export const STATUS_2_IMAGE=`${PUBLIC_STATUS}/status2.png`
export const STATUS_3_IMAGE=`${PUBLIC_STATUS}/status3.png`
export const STATUS_4_IMAGE=`${PUBLIC_STATUS}/status4.png`
export const STATUS_6_IMAGE=`${PUBLIC_STATUS}/status6.png`
export const TOC_IMAGE=`${PUBLIC_STATUS}/TOC.png`
export const Section_IMAGE=`${PUBLIC_STATUS}/section.png`
export const BASE_URL=baseUrl;